import { HttpInterceptorFn } from '@angular/common/http';

export const paramModificationInterceptor: HttpInterceptorFn = (req, next) => {
  // Skip processing for absolute URLs (external requests like S3 presigned URLs)
  if (req.url.startsWith('http://') || req.url.startsWith('https://')) {
    return next(req);
  }

  // List of endpoints that has NO alterations
  const excludedEndpoints = [
    '/api/v1/users',
    '/api/v1/user-class',
    '/api/v1/merchants-groups',
  ];

  if (excludedEndpoints.some((endpoint) => req.urlWithParams.includes(endpoint))) {
    return next(req);
  }

  const url = new URL(req.urlWithParams);
  const fdcid = url.searchParams.get('fdcid');

  if (fdcid === '1000') {
    url.searchParams.delete('fdcid');
    url.searchParams.append('fdcid', '0');

    const clonedRequest = req.clone({
      url: url.toString(),
    });

    return next(clonedRequest);
  }

  return next(req);
};
